import { cn } from "@moe/oss/utils/utils";
import { motion } from "motion/react";

interface TypingProps {
  className?: string;
  isTyping: boolean;
  name: string;
}

export function Typing({ className, name, isTyping }: TypingProps) {
  return (
    <motion.div
      initial={false}
      animate={{
        height: isTyping ? "auto" : 0,
        opacity: isTyping ? 1 : 0,
        padding: isTyping ? "0.25rem 0rem 0.125rem 0rem" : "0rem"
      }}
      transition={{ height: { duration: 0.18 }, opacity: { duration: 0.06 } }}
      className={cn(`text-tx-secondary flex w-fit items-center space-x-2 rounded-sm bg-inherit px-1`, className)}
    >
      <div>
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
      </div>
      <p className="text-sm md:text-base">
        <b>{name}</b> is typing
      </p>
    </motion.div>
  );
}
